import axios from 'axios'

const developmentURL = 'http://localhost:3000/api/'
const productionURL = 'https://morning-brew-cms-api.herokuapp.com/api/'
let baseURL;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development'){
  baseURL = developmentURL
} else {
  baseURL = productionURL
}

const headers = {
  "Content-Type": 'application/json',
}

const api = axios.create({
    baseURL,
    headers
  })

export default api;
